import styled, { css } from 'react-emotion';

export const Line = styled.div`
	border-bottom: 1px solid #d9d9d9;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-bottom: 10px;
	padding-bottom: 10px;
`

export const Title = css`
	border-bottom: none;
	color: #595959;
	flex: 0 0 auto;
	font-size: 0.875rem;

	@media (max-width: 480px) {
		&:first-child {
			flex-basis: 100%;
			text-align: center;
		}
	}
`

export const Area = styled.h3`
	font-weight: 600;
	margin: 0;
`

export const Item = styled.div`
	flex: 0 0 20%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	@media (max-width: 480px) {
		display: flex;
		flex: 1 0 100%;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: 0.5rem;
	}
`
